import type { Message } from '@/shared/api';
import { Schema } from '@/shared/lib';

import { MessageInfoSchema, type MessageInfoSchemaType } from '../../model';

type GenericMessage = { id: Message['id'] };

const MessagesParsers = {
  message: <TFrom extends GenericMessage>(data: TFrom): MessageInfoSchemaType =>
    Schema.methods.parse(MessageInfoSchema, data),

  readAt: (data: string | undefined): Date | null =>
    Schema.methods.parse(MessageInfoSchema.entries.readAt, data) ?? null,
} as const;

export { MessagesParsers };
